// extracted by mini-css-extract-plugin
module.exports = {"CardUSPContainer":"styles_CardUSPContainer__X1Jhz"};